module.exports = __webpack_public_path__ + "img/logo.017376f8.gif";